/* ---------------------------------------------------------------------------
   NÜMASHOME — Piezas de la portada

   1 · Jarrón imprimiéndose capa a capa, dibujado por código (SVG).
   2 · Carrusel deslizable para las secciones que lo pidan.

   Las dos animaciones arrancan cuando la sección entra en pantalla y van por
   tiempo, no atadas al scroll: así se ven igual de finas en el móvil, que fue
   la lección del hero.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';

  /* ====================================================== JARRÓN IMPRESO */

  var J = {
    cx: 250,
    yTop: 42,
    alto: 412,
    A: 105,            // radio máximo
    capas: 34,         // escalones de la impresión
    persp: 0.22,       // achatamiento de las elipses (cámara algo elevada)
    acanaladuras: 26,  // estrías verticales que se ven de frente

    /* Perfil de la pieza, de la boca (0) a la base (1), en fracción del radio
       máximo. Es un cilindro alto: la boca se recoge, el hombro se abre en
       seguida, el cuerpo va recto casi entero y la base se redondea. */
    perfil: [0.720, 0.905, 0.963, 0.987, 0.997,
             1.000, 1.000, 1.000, 1.000, 1.000, 1.000, 1.000, 1.000, 1.000, 1.000,
             0.998, 0.990, 0.968, 0.912, 0.830, 0.700]
  };

  function el(tag, attrs) {
    var e = document.createElementNS(NS, tag), k;
    for (k in attrs) if (attrs[k] != null) e.setAttribute(k, attrs[k]);
    return e;
  }

  // radio a la altura u (0 boca, 1 base), interpolado suave
  function radioJarron(u) {
    var P = J.perfil, n = P.length - 1;
    var x = Math.max(0, Math.min(1, u)) * n;
    var i = Math.min(n - 1, Math.floor(x)), t = x - i;
    var p0 = P[Math.max(0, i - 1)], p1 = P[i], p2 = P[i + 1], p3 = P[Math.min(n, i + 2)];
    var r = 0.5 * ((2 * p1) + (-p0 + p2) * t +
                   (2 * p0 - 5 * p1 + 4 * p2 - p3) * t * t +
                   (-p0 + 3 * p1 - 3 * p2 + p3) * t * t * t);
    return J.A * r;
  }

  function alturaJarron(u) { return J.yTop + J.alto * u; }

  /* Contorno de la pieza. No se cierra con una línea recta arriba ni abajo:
     se cierra con la mitad delantera de las elipses de la boca y de la base,
     que es lo que la hace parecer un volumen y no una plancha. */
  function siluetaJarron() {
    var N = 46, i, izq = [], der = [], u, r;
    for (i = 0; i <= N; i++) {
      u = i / N;
      r = radioJarron(u);
      izq.push((J.cx - r).toFixed(1) + ' ' + alturaJarron(u).toFixed(1));
      der.push((J.cx + r).toFixed(1) + ' ' + alturaJarron(u).toFixed(1));
    }

    var rB = radioJarron(0), rP = radioJarron(1);
    var yB = J.yTop, yP = J.yTop + J.alto;

    return 'M' + izq.join('L') +
           // base: media elipse hacia abajo
           ' A' + rP.toFixed(1) + ' ' + (rP * J.persp).toFixed(1) + ' 0 0 0 ' +
           (J.cx + rP).toFixed(1) + ' ' + yP.toFixed(1) +
           'L' + der.reverse().join('L') +
           // boca: la mitad delantera, también hacia abajo
           ' A' + rB.toFixed(1) + ' ' + (rB * J.persp).toFixed(1) + ' 0 0 1 ' +
           (J.cx - rB).toFixed(1) + ' ' + yB.toFixed(1) + 'Z';
  }

  /* Las estrías. Cada una sigue el perfil, así que se estrecha donde la pieza
     se estrecha, y arranca y muere sobre las elipses de la boca y de la base.
     Se reparten por ángulo, no por anchura: por eso se apretujan hacia los
     cantos, igual que en la pieza real. */
  function acanaladuras() {
    var n = J.acanaladuras, paso = Math.PI / n;
    var valles = [], crestas = [], k;
    var M = 24;
    var rB = radioJarron(0), rP = radioJarron(1);

    function trazo(theta) {
      var sen = Math.sin(theta), cos = Math.cos(theta), pts = [], j, u, r, y;
      for (j = 0; j <= M; j++) {
        u = j / M;
        r = radioJarron(u);
        // desplazamiento en vertical por la perspectiva: máximo en los
        // extremos (sobre las elipses) y nulo por el medio de la pieza
        y = alturaJarron(u) + J.persp * cos *
            (u < 0.5 ? rB * (1 - 2 * u) : rP * (2 * u - 1));
        pts.push((J.cx + r * sen).toFixed(1) + ' ' + y.toFixed(1));
      }
      return 'M' + pts.join('L');
    }

    for (k = 0; k < n; k++) {
      valles.push(trazo(-Math.PI / 2 + paso * (k + 0.5)));
      if (k < n - 1) crestas.push(trazo(-Math.PI / 2 + paso * (k + 1)));
    }
    return { valles: valles.join(' '), crestas: crestas.join(' ') };
  }

  function dibujarJarron(host) {
    if (host.dataset.listo) return;
    host.dataset.listo = '1';

    var uid = 'nj' + Math.random().toString(36).slice(2, 7);
    var svg = el('svg', {
      viewBox: '0 0 500 500',
      class: 'numa-jarron__svg',
      role: 'img',
      'aria-label': 'El jarrón Solen construyéndose capa a capa'
    });
    var defs = el('defs');
    svg.appendChild(defs);

    var silueta = siluetaJarron();
    var estrias = acanaladuras();
    var rB = radioJarron(0);

    // el material: degradado de lado a lado
    var g = el('linearGradient', { id: uid + 'mat', x1: J.cx - J.A, y1: 0, x2: J.cx + J.A, y2: 0,
      gradientUnits: 'userSpaceOnUse' });
    [[0, '#bdb1a0'], [.30, '#e8e1d5'], [.58, '#f7f3ea'], [.86, '#ddd4c5'], [1, '#b9ac99']].forEach(function (s) {
      g.appendChild(el('stop', { offset: s[0], 'stop-color': s[1] }));
    });
    defs.appendChild(g);

    // la impresión se descubre de abajo arriba: un rectángulo que crece
    var cp = el('clipPath', { id: uid + 'crece', clipPathUnits: 'userSpaceOnUse' });
    cp.appendChild(el('rect', { x: 0, y: J.yTop - 40, width: 500, height: J.alto + 40,
      class: 'numa-jarron__crece' }));
    defs.appendChild(cp);

    // recorte con la forma de la pieza, para que las estrías no se salgan
    var cf = el('clipPath', { id: uid + 'forma', clipPathUnits: 'userSpaceOnUse' });
    cf.appendChild(el('path', { d: silueta }));
    defs.appendChild(cf);

    // las líneas de capa, como patrón (discretas: aquí mandan las estrías)
    var pat = el('pattern', { id: uid + 'capas', patternUnits: 'userSpaceOnUse',
      x: 0, y: J.yTop, width: 10, height: J.alto / J.capas });
    pat.appendChild(el('rect', { x: 0, y: 0, width: 10, height: (J.alto / J.capas) - 1.1,
      fill: 'rgba(120,100,78,.05)' }));
    defs.appendChild(pat);

    // sombra de apoyo
    svg.appendChild(el('ellipse', { cx: J.cx, cy: J.yTop + J.alto + 14,
      rx: radioJarron(1) * 1.7, ry: 10, fill: 'rgba(90,74,58,.13)' }));

    // la pieza, recortada por el rectángulo que crece
    var pieza = el('g', { 'clip-path': 'url(#' + uid + 'crece)' });

    pieza.appendChild(el('path', { d: silueta, fill: 'url(#' + uid + 'mat)' }));

    var relieve = el('g', { 'clip-path': 'url(#' + uid + 'forma)' });
    relieve.appendChild(el('path', { d: estrias.valles, fill: 'none',
      stroke: 'rgba(116,102,84,.42)', 'stroke-width': 1.35 }));
    relieve.appendChild(el('path', { d: estrias.crestas, fill: 'none',
      stroke: 'rgba(255,255,255,.5)', 'stroke-width': 1.7 }));
    pieza.appendChild(relieve);

    pieza.appendChild(el('path', { d: silueta, fill: 'url(#' + uid + 'capas)' }));

    // la boca: el borde y el hueco, que la pieza es hueca
    pieza.appendChild(el('ellipse', { cx: J.cx, cy: J.yTop, rx: rB, ry: rB * J.persp,
      fill: '#efe8dc' }));
    pieza.appendChild(el('ellipse', { cx: J.cx, cy: J.yTop + 1.5,
      rx: rB * 0.80, ry: rB * 0.80 * J.persp, fill: '#9a8d7a' }));
    pieza.appendChild(el('ellipse', { cx: J.cx, cy: J.yTop + 3.5,
      rx: rB * 0.80, ry: rB * 0.80 * J.persp, fill: 'none',
      stroke: 'rgba(255,255,255,.35)', 'stroke-width': 1.4 }));

    // canto iluminado del contorno
    pieza.appendChild(el('path', { d: silueta, fill: 'none',
      stroke: 'rgba(255,255,255,.45)', 'stroke-width': 1.2 }));

    svg.appendChild(pieza);

    // El cabezal deposita el material. Van dos grupos anidados porque son
    // dos movimientos a la vez y un solo transform no puede con los dos:
    // el de fuera sube capa a capa, el de dentro hace el vaivén.
    var cabezal = el('g', { class: 'numa-jarron__cabezal' });
    var vaiven = el('g', { class: 'numa-jarron__vaiven' });
    vaiven.appendChild(el('rect', { x: -13, y: -22, width: 26, height: 17, rx: 3, fill: '#3a342c' }));
    vaiven.appendChild(el('path', { d: 'M-5 -5 L5 -5 L2.4 3 L-2.4 3 Z', fill: '#5d564b' }));
    vaiven.appendChild(el('circle', { cx: 0, cy: 5, r: 2, fill: '#b5502a' }));
    cabezal.appendChild(vaiven);
    svg.appendChild(cabezal);

    host.appendChild(svg);
    return svg;
  }

  /* Arranca la impresión cuando la pieza entra en pantalla, y la rearranca
     si se vuelve a ella. Por tiempo, no por scroll. */
  function observarJarron(host) {
    var svg = dibujarJarron(host);
    if (!svg) return;

    if (!('IntersectionObserver' in window)) { host.classList.add('numa-jarron--va'); return; }

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          host.classList.remove('numa-jarron--va');
          void host.offsetWidth;            // reinicia la animación
          host.classList.add('numa-jarron--va');
        }
      });
    }, { threshold: 0.35 });
    io.observe(host);
  }

  /* ============================================================ CARRUSEL

     Deslizamiento horizontal con anclaje (scroll-snap), que lo lleva el
     propio navegador: en el móvil se arrastra con el dedo y en escritorio
     con las flechas o la rueda. Nada atado al scroll de la página.        */

  function montarCarrusel(pista) {
    if (pista.dataset.listo) return;
    pista.dataset.listo = '1';

    var caja = pista.parentElement;
    var previo = caja.querySelector('[data-numa-previo]');
    var siguiente = caja.querySelector('[data-numa-siguiente]');
    var puntos = caja.querySelector('[data-numa-puntos]');
    var tarjetas = pista.children;

    function paso() {
      return tarjetas.length ? tarjetas[0].getBoundingClientRect().width + 18 : 320;
    }
    function ir(dir) {
      pista.scrollBy({ left: dir * paso(), behavior: 'smooth' });
    }
    if (previo) previo.addEventListener('click', function () { ir(-1); });
    if (siguiente) siguiente.addEventListener('click', function () { ir(1); });

    // puntos indicadores
    if (puntos) {
      for (var i = 0; i < tarjetas.length; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'numa-carrusel__punto';
        b.setAttribute('aria-label', 'Ir a la tarjeta ' + (i + 1));
        b.dataset.i = i;
        b.addEventListener('click', function () {
          pista.scrollTo({ left: tarjetas[this.dataset.i].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
        });
        puntos.appendChild(b);
      }
    }

    function marcar() {
      var centro = pista.scrollLeft + pista.clientWidth / 2;
      var activo = 0, mejor = Infinity;
      for (var i = 0; i < tarjetas.length; i++) {
        var c = tarjetas[i].offsetLeft - pista.offsetLeft + tarjetas[i].offsetWidth / 2;
        var d = Math.abs(c - centro);
        if (d < mejor) { mejor = d; activo = i; }
      }
      if (puntos) {
        for (var j = 0; j < puntos.children.length; j++) {
          puntos.children[j].classList.toggle('es-activo', j === activo);
        }
      }
      if (previo) previo.disabled = pista.scrollLeft < 4;
      if (siguiente) siguiente.disabled = pista.scrollLeft > pista.scrollWidth - pista.clientWidth - 4;
    }

    var pedido = false;
    pista.addEventListener('scroll', function () {
      if (pedido) return;
      pedido = true;
      requestAnimationFrame(function () { pedido = false; marcar(); });
    }, { passive: true });

    window.addEventListener("resize", marcar, { passive: true });
    marcar();

    // el guiño de deslizamiento, solo la primera vez que se ve
    if ("IntersectionObserver" in window) {
      var ioC = new IntersectionObserver(function (ent) {
        if (!ent[0].isIntersecting) return;
        ioC.disconnect();
        setTimeout(function () { insinuarPista(pista); }, 380);
      }, { threshold: 0.4 });
      ioC.observe(pista);
    }
  }

  /* Pista visible por primera vez: se asoma un poco hacia la derecha y
     vuelve. Es la manera de que se vea que hay más contenido al lado sin
     tener que escribirlo. */
  function insinuarPista(pista) {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (pista.scrollWidth - pista.clientWidth < 40) return;
    pista.scrollTo({ left: 54, behavior: "smooth" });
    setTimeout(function () {
      pista.scrollTo({ left: 0, behavior: "smooth" });
    }, 620);
  }

  /* ============================================================== arranque */

  function arrancar() {
    var jarrones = document.querySelectorAll('[data-numa-jarron]');
    for (var i = 0; i < jarrones.length; i++) observarJarron(jarrones[i]);

    var pistas = document.querySelectorAll('[data-numa-carrusel]');
    for (var j = 0; j < pistas.length; j++) montarCarrusel(pistas[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
